/**
 * Maps a Case Appeals table row into the Pharma STP model shape expected by
 * the Non-EPA Edit Summary modal.
 */

import { CaseAppealsTableRowData } from "../../../data-model/caseAppealsTable";
import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";

/**
 * Builds a `PharmaStpFileModel` from a Case Appeals row so View/Edit can open
 * the same Non-EPA Edit Summary modal used on the calling worklist.
 *
 * @param row - Formatted Case Appeals table row
 * @returns Order-shaped payload for {@link NonEpaModal}
 */
export const mapAppealRowToNonEpaModalData = (
  row: CaseAppealsTableRowData,
): PharmaStpFileModel => {
  const identifier = String(row.identifier ?? "").trim();
  const coverMyMedsId = String(row.covermymed_id ?? "").trim();

  return {
    identifier,
    seq: "",
    poc: String(row.appeal_poc ?? "").trim(),
    pharmacy_type: "",
    patient_mrn: String(row.patient_mrn ?? "").trim(),
    patient_name: String(row.patient_name ?? "").trim(),
    dob: String(row.dob ?? "").trim(),
    insuranceid: "",
    provider_name: "",
    drug: String(row.drug ?? "").trim(),
    pharmacy: "",
    bin: "",
    pharmacy_phone: null,
    rx_due_date: "",
    covermymed_id: coverMyMedsId,
    response_status: row.response_status ?? null,
    second_stp_status: row.second_stp_status ?? null,
    sftp_status: null,
    filename: String(row.filename ?? "").trim(),
    org_id: "",
    dumped_at: String(row.dumped_at ?? "").trim(),
    non_epa_reason: String(row.appeal_reason ?? "").trim() || null,
    non_epa_comment: String(row.appeal_comment ?? "").trim() || null,
    non_epa_poc: String(row.appeal_poc ?? "").trim() || null,
    appeal_type: row.appeal_type ?? null,
    appeal_status: row.appeal_status ?? null,
    appeal_reason: row.appeal_reason ?? null,
    appeal_comments: row.appeal_comment ?? null,
    // Denial summary joined onto the appeal list row; the modal shows it as the appeal summary.
    pa_outcome_provider_summary: row.pa_outcome_provider_summary ?? null,
  };
};
